export default "__VITE_ASSET__eWNEpZdh__"